import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-banking-case",
  templateUrl: "./banking-case.component.html",
})
export class BankingCaseComponent implements OnInit {
  code = {};

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    const externalReference = JSON.parse(
      localStorage.getItem("EXTERNAL_REFERENCE") as string
    );
    const openBankingUserToken = JSON.parse(
      localStorage.getItem("OPEN_BANKING_USER_TOKEN") as string
    );
    const openBankingBackendOrigin = JSON.parse(
      localStorage.getItem("OPEN_BANKING_BACKEND_ORIGIN") as string
    );

    this.http
      .get<any>(
        openBankingBackendOrigin +
          "/open-banking-case?code=selling_case_id&id=" +
          externalReference,
        {
          headers: {
            Authorization: `Bearer ${openBankingUserToken}`,
          },
        }
      )
      .subscribe((data) => {
        this.code = data;
      });
  }
}
